export default __webpack_public_path__ + "static/media/178w.62918c19.svg";